<script setup>
import { defineProps} from "vue";
import NotaFiscalService from "@/api/v2/services/NotaFiscalService";
import UtilMoney from "@/utils/UtilMoney";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "controlesDesativados",
    "dado",
]);

//==================================================================//
//=================== Pega Nota Fiscal Emitida =====================//
//==================================================================//

const baixarNotaFiscalEmitida = async ()=>{

    let notaFiscalResponse = await NotaFiscalService.getNotaFiscalByPlugNotasId({
        nomeArquivo: props?.dado?.chaveAcesso,
        plugNotasId: props?.dado?.plugNotasID
    });
    if(notaFiscalResponse.status != "200"){
        throw new Error(`${notaFiscalResponse.message}`)
    }

};

</script>

<template>

    <v-card class="c-cartao">

        <v-card-title class="c-cartao__header">

            <div class="c-cartao__titulo">

                <div class="c-titulo__controles">

                    <v-tooltip bottom>

                        <template v-slot:activator="{ on, attrs }">

                            <v-btn
                                class="c-baixar-nota-fiscal-emitida mx-2"
                                fab
                                dark
                                small
                                color="#3E737B"
                                v-bind="attrs"
                                v-on="on"
                                @click="baixarNotaFiscalEmitida"
                            >

                                <v-icon dark>
                                    mdi-download
                                </v-icon>
                            
                            </v-btn>

                        </template>

                        <span>
                            Baixar Nota Fiscal Emitida
                        </span>

                    </v-tooltip>

                </div>

                <h3 class="c-titulo__texto">
                    {{props?.dado?.origem}} {{props?.dado?.numero}}
                </h3>

            </div>

        </v-card-title>

        <div class="c-cartao__conteudo">

            <div class="c-conjunto-de-campos">

                <div class="c-campo">

                    <v-text-field class="c-campo__input"
                        label="Job"
                        :value="props?.dado?.jobCodigo"
                        disabled
                        outlined
                        return-object
                        hide-details
                    ></v-text-field>

                </div>

                <div class="c-campo">

                    <v-text-field class="c-campo__input"
                        label="Cliente"
                        :value="props?.dado?.clienteNome"
                        disabled
                        outlined
                        return-object
                        hide-details
                    ></v-text-field>

                </div>

                <div class="c-campo">

                    <v-text-field class="c-campo__input"
                        label="Data Criação"
                        :value="props?.dado?.dataCriacao"
                        disabled
                        outlined
                        return-object
                        hide-details
                    ></v-text-field>

                </div>

            </div>

            <v-divider></v-divider>

            <div class="c-conjunto-de-campos">

                <div class="c-campo">
            
                    <v-text-field class="c-campo__input"
                        label="Valor Original"
                        :value="UtilMoney.toR$BRL(props?.dado?.valorOriginal)"
                        disabled
                        outlined
                        return-object
                        hide-details
                    ></v-text-field>

                </div>

                <div class="c-campo">
                
                    <v-text-field class="c-campo__input"
                        label="Valor Liquidado"
                        :value="UtilMoney.toR$BRL(props?.dado?.valorRecebido)"
                        disabled
                        outlined
                        return-object
                        hide-details
                    ></v-text-field>

                </div>

                <div class="c-campo">
                
                    <v-text-field class="c-campo__input"
                        label="Valor a Liquidar"
                        :value="UtilMoney.toR$BRL(props?.dado?.valorParaReceber)"
                        disabled
                        outlined
                        return-object
                        hide-details
                    ></v-text-field>

                </div>

            </div>

        </div>

    </v-card>

</template>

<style scoped>

/*==================================================================*/
/*======================== Cartão Header ===========================*/
/*==================================================================*/

.c-cartao__header{
    display: grid; 
    grid-template-columns: 1fr; 
    grid-template-rows: max-content; 
    gap: 10px;
    grid-template-areas: 
        "titulo";
}

.c-cartao__titulo{
    display: flex;
    flex-direction: row;
    align-items: center;
    grid-area: titulo;
}

.c-cartao__conteudo{
    display: grid;
    grid-gap: 20px;
}

/*==================================================================*/
/*======================= Conjunto de Campos =======================*/
/*==================================================================*/

.c-conjunto-de-campos{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
    grid-gap: 20px;
}

/*==================================================================*/
/*=================== Baixar Nota Fiscal Emitida ===================*/
/*==================================================================*/

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-baixar-nota-fiscal-emitida{
    background: #3E737B !important;
    border-color: #3E737B !important;
}

</style>